module.exports = __webpack_public_path__ + "app/modals/delete-message-board.view.html";